export default "__VITE_ASSET__AonfbFrS__"